module.exports = __webpack_public_path__ + "static/logo_dark-0c802585dedebb5deefe541b1f19a017.svg";